<img class="avatar" [src]="url" onContextMenu="return false;" />
<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)">
  <ng-template
    ngx-file-drop-content-tmp
    let-openFileSelector="openFileSelector"
  >
    @if (!isDisabled && userId) {
    <img
      class="camera"
      [src]="camera"
      onContextMenu="return false;"
      (click)="openFileSelector()"
    />
    }
  </ng-template>
</ngx-file-drop>
